document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('a.ucui_show').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            window.UC_UI?.showSecondLayer()
        })
    })
});
